import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainAllocationUpdateMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  userPackages?: Types.InputMaybe<Array<Types.AllocationInput>>;
  deviceTypeSets?: Types.InputMaybe<Array<Types.AllocationInput>>;
  capabilitySets?: Types.InputMaybe<Array<Types.AllocationInput>>;
  services?: Types.InputMaybe<Types.ServicesAllocationInput>;
}>;


export type DomainAllocationUpdateMutation = { __typename?: 'Mutation', domainAllocationUpdate: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } };

export type DomainQuotaDefaultsUpdateMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  userPackageName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  devices?: Types.InputMaybe<Array<Types.AllocationInput>>;
  capabilities?: Types.InputMaybe<Array<Types.Scalars['String']['input']>>;
}>;


export type DomainQuotaDefaultsUpdateMutation = { __typename?: 'Mutation', domainQuotaDefaultsUpdate: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } };

export type DomainBulkCapabilityUpdateMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  changes: Array<Types.InputMaybe<Types.CapabilityModification>>;
}>;


export type DomainBulkCapabilityUpdateMutation = { __typename?: 'Mutation', domainBulkCapabilityUpdate?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };


export const DomainAllocationUpdateDocument = gql`
    mutation DomainAllocationUpdate($domainId: Int!, $userPackages: [AllocationInput!], $deviceTypeSets: [AllocationInput!], $capabilitySets: [AllocationInput!], $services: ServicesAllocationInput) {
  domainAllocationUpdate(
    domainId: $domainId
    userPackages: $userPackages
    deviceTypeSets: $deviceTypeSets
    capabilitySets: $capabilitySets
    services: $services
  ) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type DomainAllocationUpdateMutationFn = Apollo.MutationFunction<DomainAllocationUpdateMutation, DomainAllocationUpdateMutationVariables>;

/**
 * __useDomainAllocationUpdateMutation__
 *
 * To run a mutation, you first call `useDomainAllocationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainAllocationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainAllocationUpdateMutation, { data, loading, error }] = useDomainAllocationUpdateMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      userPackages: // value for 'userPackages'
 *      deviceTypeSets: // value for 'deviceTypeSets'
 *      capabilitySets: // value for 'capabilitySets'
 *      services: // value for 'services'
 *   },
 * });
 */
export function useDomainAllocationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DomainAllocationUpdateMutation, DomainAllocationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainAllocationUpdateMutation, DomainAllocationUpdateMutationVariables>(DomainAllocationUpdateDocument, options);
      }
export type DomainAllocationUpdateMutationHookResult = ReturnType<typeof useDomainAllocationUpdateMutation>;
export type DomainAllocationUpdateMutationResult = Apollo.MutationResult<DomainAllocationUpdateMutation>;
export type DomainAllocationUpdateMutationOptions = Apollo.BaseMutationOptions<DomainAllocationUpdateMutation, DomainAllocationUpdateMutationVariables>;
export const DomainQuotaDefaultsUpdateDocument = gql`
    mutation DomainQuotaDefaultsUpdate($domainId: Int!, $userPackageName: String, $devices: [AllocationInput!], $capabilities: [String!]) {
  domainQuotaDefaultsUpdate(
    domainId: $domainId
    userPackageName: $userPackageName
    devices: $devices
    capabilities: $capabilities
  ) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type DomainQuotaDefaultsUpdateMutationFn = Apollo.MutationFunction<DomainQuotaDefaultsUpdateMutation, DomainQuotaDefaultsUpdateMutationVariables>;

/**
 * __useDomainQuotaDefaultsUpdateMutation__
 *
 * To run a mutation, you first call `useDomainQuotaDefaultsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainQuotaDefaultsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainQuotaDefaultsUpdateMutation, { data, loading, error }] = useDomainQuotaDefaultsUpdateMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      userPackageName: // value for 'userPackageName'
 *      devices: // value for 'devices'
 *      capabilities: // value for 'capabilities'
 *   },
 * });
 */
export function useDomainQuotaDefaultsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DomainQuotaDefaultsUpdateMutation, DomainQuotaDefaultsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainQuotaDefaultsUpdateMutation, DomainQuotaDefaultsUpdateMutationVariables>(DomainQuotaDefaultsUpdateDocument, options);
      }
export type DomainQuotaDefaultsUpdateMutationHookResult = ReturnType<typeof useDomainQuotaDefaultsUpdateMutation>;
export type DomainQuotaDefaultsUpdateMutationResult = Apollo.MutationResult<DomainQuotaDefaultsUpdateMutation>;
export type DomainQuotaDefaultsUpdateMutationOptions = Apollo.BaseMutationOptions<DomainQuotaDefaultsUpdateMutation, DomainQuotaDefaultsUpdateMutationVariables>;
export const DomainBulkCapabilityUpdateDocument = gql`
    mutation DomainBulkCapabilityUpdate($domainId: Int!, $changes: [CapabilityModification]!) {
  domainBulkCapabilityUpdate(domainId: $domainId, changes: $changes) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type DomainBulkCapabilityUpdateMutationFn = Apollo.MutationFunction<DomainBulkCapabilityUpdateMutation, DomainBulkCapabilityUpdateMutationVariables>;

/**
 * __useDomainBulkCapabilityUpdateMutation__
 *
 * To run a mutation, you first call `useDomainBulkCapabilityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainBulkCapabilityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainBulkCapabilityUpdateMutation, { data, loading, error }] = useDomainBulkCapabilityUpdateMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useDomainBulkCapabilityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DomainBulkCapabilityUpdateMutation, DomainBulkCapabilityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainBulkCapabilityUpdateMutation, DomainBulkCapabilityUpdateMutationVariables>(DomainBulkCapabilityUpdateDocument, options);
      }
export type DomainBulkCapabilityUpdateMutationHookResult = ReturnType<typeof useDomainBulkCapabilityUpdateMutation>;
export type DomainBulkCapabilityUpdateMutationResult = Apollo.MutationResult<DomainBulkCapabilityUpdateMutation>;
export type DomainBulkCapabilityUpdateMutationOptions = Apollo.BaseMutationOptions<DomainBulkCapabilityUpdateMutation, DomainBulkCapabilityUpdateMutationVariables>;